// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1J4kX","title":"AfterFrontImage_title__3_kYK"};